import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import { authService } from '@/services/auth.service';
import { Button } from '@/components/ui/button';

export const VerifyEmailPage = () => {
  const { token } = useParams<{ token: string }>();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

  useEffect(() => {
    if (!token) { setStatus('error'); return; }
    authService.verifyEmail(token)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="text-center max-w-sm">
        {status === 'loading' && (
          <>
            <Loader2 className="h-16 w-16 text-primary-400 animate-spin mx-auto mb-4" />
            <h2 className="font-heading font-bold text-xl text-gray-800">Verifying your email...</h2>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="h-10 w-10 text-success" />
            </div>
            <h2 className="font-heading font-bold text-2xl text-gray-800 mb-2">Email Verified!</h2>
            <p className="text-gray-500 mb-6">Your account is now active. You can sign in and start shopping.</p>
            <Button asChild><Link to="/login">Go to Login</Link></Button>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-20 h-20 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
              <XCircle className="h-10 w-10 text-error" />
            </div>
            <h2 className="font-heading font-bold text-2xl text-gray-800 mb-2">Verification Failed</h2>
            <p className="text-gray-500 mb-6">The link is invalid or has expired. Please request a new verification email.</p>
            <Button variant="outline" asChild><Link to="/login">Back to Login</Link></Button>
          </>
        )}
      </div>
    </div>
  );
};
